import { useEffect } from "react";
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { ADMIN_PATH } from "./lib/api";
import { Header } from "./components/layout/Header";
import { Floaters, Footer } from "./components/layout/Footer";
import HomePage from "./pages/HomePage";
import OpportunitiesPage from "./pages/OpportunitiesPage";
import OpportunityPage from "./pages/OpportunityPage";
import MyPage from "./pages/MyPage";
import AchievementsPage from "./pages/AchievementsPage";
import CoordinatorPage from "./pages/CoordinatorPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminOpportunities from "./pages/admin/AdminOpportunities";
import AdminRegistrations from "./pages/admin/AdminRegistrations";
import AdminCoordinators from "./pages/admin/AdminCoordinators";
import AdminAchievements from "./pages/admin/AdminAchievements";

function SmoothScroll() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return undefined; // native scroll on touch devices
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);
  useEffect(() => {
    if (hash) { const el = document.querySelector(hash); if (el) setTimeout(() => (window.__lenis ? window.__lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView()), 80); }
    else { window.__lenis ? window.__lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0); }
  }, [pathname, hash]);
  return null;
}

const SiteLayout = () => (
  <div className="site">
    <SmoothScroll />
    <Header />
    <Outlet />
    <Footer />
    <Floaters />
  </div>
);

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/opportunities" element={<OpportunitiesPage />} />
              <Route path="/opportunities/:id" element={<OpportunityPage />} />
              <Route path="/my" element={<MyPage />} />
              <Route path="/my/:code" element={<MyPage />} />
              <Route path="/achievements" element={<AchievementsPage />} />
              <Route path="/coordinator" element={<CoordinatorPage />} />
            </Route>
            <Route path={ADMIN_PATH} element={<AdminLogin />} />
            <Route path={`${ADMIN_PATH}/panel`} element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="opportunities" element={<AdminOpportunities />} />
              <Route path="registrations" element={<AdminRegistrations />} />
              <Route path="coordinators" element={<AdminCoordinators />} />
              <Route path="achievements" element={<AdminAchievements />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}
